(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.querySelector('[data-email-popup]');
    if (!popup) return;

    const STORAGE_KEY = 'lh:email-popup:dismissed';
    const SUBSCRIBED_KEY = 'lh:email-popup:subscribed';
    const SUPPRESS_DAYS = 30;

    const dismissedAt = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    const isSuppressed = Date.now() - dismissedAt < SUPPRESS_DAYS * 86400 * 1000;
    const isSubscribed = localStorage.getItem(SUBSCRIBED_KEY) === '1';

    if (isSuppressed || isSubscribed) return;

    const delaySec = parseInt(popup.dataset.delay || '30', 10);

    let opened = false;
    const open = () => {
      if (opened) return;
      opened = true;
      popup.hidden = false;
    };
    const close = () => {
      popup.hidden = true;
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    };

    setTimeout(open, Math.max(5000, delaySec * 1000));

    let scrollTriggered = false;
    window.addEventListener('scroll', () => {
      if (scrollTriggered) return;
      const ratio = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (ratio > 0.6) {
        scrollTriggered = true;
        open();
      }
    }, { passive: true });

    for (const b of popup.querySelectorAll('[data-email-close]')) {
      b.addEventListener('click', close);
    }

    popup.querySelector('form')?.addEventListener('submit', () => {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-overlay"] && !Shopify.designMode) return;
  try {
    class SearchOverlay extends HTMLElement {
    #lastTrigger = null;

    connectedCallback() {
      this.dialog = this.querySelector('[data-search-dialog]');
      this.input = this.querySelector('[data-search-input]');
      if (!this.dialog) return;

      for (const t of document.querySelectorAll('[data-search-toggle]')) {
        t.addEventListener('click', () => {
          this.#lastTrigger = t;
          this.open();
        });
      }
      for (const c of this.querySelectorAll('[data-search-close]')) {
        c.addEventListener('click', () => this.close());
      }
      this.dialog.addEventListener('close', () => {
        if (this.#lastTrigger?.focus) this.#lastTrigger.focus();
        this.#lastTrigger = null;
      });
    }

    open() {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
      for (const t of document.querySelectorAll('[data-search-toggle]')) {
        t.setAttribute('aria-expanded', 'true');
      }
      window.requestAnimationFrame(() => this.input?.focus());
    }

    close() {
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      for (const t of document.querySelectorAll('[data-search-toggle]')) {
        t.setAttribute('aria-expanded', 'false');
      }
    }
  }

  if (!customElements.get('search-overlay')) {
    customElements.define('search-overlay', SearchOverlay);
  }
  } catch(e) { console.error(e); }
})();

})();
